import { c as _c } from "react/compiler-runtime";
import type { IDialogControl } from '@/components/Molecules/Dialog/Dialog';
import { Dialog, DialogActions, DialogActionsMain } from '@/components/Molecules/Dialog/Dialog';
import useTranslation from '@/hooks/useTranslation';
import { useRef } from 'react';
import type { FCh } from 'react-fc';
interface IProps {
  dialog: IDialogControl;
  onCancel?: () => void;
  onConfirm: () => void;
}
export const ConfirmationDialog: FCh<IProps> = t0 => {
  const $ = _c(28);
  const {
    onCancel,
    onConfirm,
    children,
    dialog
  } = t0;
  const {
    t
  } = useTranslation();
  const isConfirm = useRef(false);
  let t1;
  if ($[0] !== t) {
    t1 = t("Actions.confirm_question");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onCancel || $[3] !== onConfirm) {
    t2 = () => {
      if (isConfirm.current) {
        onConfirm();
      } else {
        onCancel?.();
      }
      isConfirm.current = false;
    };
    $[2] = onCancel;
    $[3] = onConfirm;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== dialog) {
    t3 = () => {
      isConfirm.current = true;
      dialog.close();
    };
    $[5] = dialog;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("Actions.delete");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <button className="cds-button--destruction" type="button" onClick={t3}>{t4}</button>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== dialog) {
    t6 = () => {
      isConfirm.current = false;
      dialog.close();
    };
    $[12] = dialog;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("Actions.cancel");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <button className="cds-button--primary" type="submit" onClick={t6}>{t7}</button>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t5 || $[20] !== t8) {
    t9 = <DialogActions><DialogActionsMain>{t5}{t8}</DialogActionsMain></DialogActions>;
    $[19] = t5;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== children || $[23] !== dialog || $[24] !== t1 || $[25] !== t2 || $[26] !== t9) {
    t10 = <Dialog title={t1} {...dialog} onClose={t2}>{children}{t9}</Dialog>;
    $[22] = children;
    $[23] = dialog;
    $[24] = t1;
    $[25] = t2;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};